import { Currency, DisplayType } from "@mcleod/core";
import { AutogenLayoutFuelGlControl } from "./autogen/AutogenLayoutFuelGlControl";
import { ChangeEvent, Switch, TableRow, TableRowBeforeSaveEvent, Snackbar, TableRowDisplayEvent, Textbox, LookupModelSelectionEvent, DataDisplayEvent } from "@mcleod/components";

export class FuelGlControl extends AutogenLayoutFuelGlControl {

    /** This is an event handler for the beforeRowSave event of tableProducts. */
    tableProductsBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data;
        const textboxCompanyGlid = tableRow.findComponentById("textboxCompanyGlid");
        const textboxOwnerGlid = tableRow.findComponentById("textboxOwnerGlid");
        const hasGlid = !modelRow.isNull("company_glid") || !modelRow.isNull("owner_glid");
        if (!hasGlid) {
            Snackbar.showWarningSnackbar("One of the GL Accounts must be populated");
        }
        textboxCompanyGlid?.setProps({ required: !hasGlid });
        textboxOwnerGlid?.setProps({ required: !hasGlid });
    }

    /** This is an event handler for the onRowDisplay event of tableProducts. */
    tableProductsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxProductCode = tableRow.findComponentById("textboxProductCode") as Textbox;
        textboxProductCode?.addBeforeLookupModelSearchListener(event => event.filter.interface_id = tableRow.data.get("interface_id"));
        const switchDeductOwner = tableRow.findComponentById("switchOwnerCreateDeduction") as Switch;
        this.updateDeductTextbox(switchDeductOwner, tableRow);
        const switchCompCreateDeduct = tableRow.findComponentById("switchCompCreateDeduction") as Switch;
        this.updateDeductTextbox(switchCompCreateDeduct, tableRow);
    }

    deductSwitchOnChange(event: ChangeEvent) {
        const switchDeduct = event.target as Switch;
        const tableRow = TableRow.getContainingTableRow(switchDeduct);
        this.updateDeductTextbox(switchDeduct, tableRow);
    }

    updateDeductTextbox(switchDeduct: Switch, tableRow: TableRow) {
        const textboxDeductAmount = switchDeduct.id == "switchOwnerCreateDeduction" ?
            tableRow.findComponentById("textboxOwnerDedCode") :
            tableRow.findComponentById("textboxCompanyDedCode");
        textboxDeductAmount?.setProps({ enabled: switchDeduct.checked, required: switchDeduct.checked });
    }

    /** This is an event handler for the onLookupModelSelection event of textboxInterfaceId. */
    textboxInterfaceIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target as Textbox);
        const textboxProductCode = tableRow.findComponentById("textboxProductCode") as Textbox;
        tableRow.data.setValueAndLookupModelData("product_code", null, null);
        textboxProductCode?.setProps({ enabled: event.hasSelection() });
        textboxProductCode?.clear();
    }

    optionOnChange(event: ChangeEvent) {
        const dropdown = event.target as Textbox;
        const amountTextbox = this.getCorrespondingDropdownTextbox(dropdown);
        if (this.activeRow.isNull(amountTextbox.field)) {
            return;
        }
        const option = dropdown.selectedItem;
        amountTextbox.displayType = ["P", "A"].includes(option.value) ? DisplayType.FLOAT : DisplayType.CURRENCY;
        const newValue = ["P", "A"].includes(option.value)
            ? this.activeRow.get(amountTextbox.field)?.amount ?? this.activeRow.get(amountTextbox.field, null)
            : new Currency(this.activeRow.get(amountTextbox.field));
        this.activeRow.set(amountTextbox.field, newValue);
        amountTextbox.clear();
        amountTextbox.displayData(this.activeRow, null, 0);
    }

    getCorrespondingDropdownTextbox(textbox: Textbox): Textbox {
        switch (textbox) {
            case this.textboxDrLocalFeeAdvOnlyCode:
                return this.textboxDrLocalFeeAdvOnlyFee;
            case this.textboxDrLocalFeeFuelAdvCode:
                return this.textboxDrLocalFeeFuelAdvFee;
            case this.textboxLoLocalFeeFuelOnlyCode:
                return this.textboxLoLocalFeeFuelOnlyFee;
            case this.textboxLoLocalFeeAdvOnlyCode:
                return this.textboxLoLocalFeeAdvOnlyFee;
            case this.textboxLoLocalFeeFuelAdvCode:
                return this.textboxLoLocalFeeFuelAdvFee;
        }
    }

    amountOnDataDisplay(event: DataDisplayEvent) {
        const textbox = event.target as Textbox;
        if (event.rowData) {
            const data = event.rowData.get(textbox.field);
            if (textbox.displayType == DisplayType.FLOAT && data?.amount != null) {
                event.rowData.set(textbox.field, data.amount);
            }
        }
    }
}
